import { HOVER_REVEAL_CLASS, HOVER_ROW_CLASS } from 'utils/surfaceClasses';

/**
 * The edit and delete buttons of a comment stay out of sight until its row is
 * hovered or holds the keyboard focus, so that a thread reads as text (the
 * shared rule of utils/surfaceClasses). Shared by the CRM thread and the
 * invoice comments tab.
 */
export const COMMENT_ROW_CLASS = HOVER_ROW_CLASS;

export const COMMENT_ACTIONS_REVEAL_CLASS = HOVER_REVEAL_CLASS;
